module.exports = __webpack_public_path__ + "img/slide3.e19698ce.webp";